export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7729.72ce1620.jpg";